import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Input,
  Typography,
} from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const AppointmentCancelConfirmation = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [showError, setShowError] = React.useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "cancel-popover" : undefined;

  const dateTime = moment(new Date()).format("YYYY-MM-DD hh:mm a");

  return (
    <>
      <Button
        type="button"
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleClick}
        disabled={props.disableSubmit}
      >
        E Signature
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"E-signature "}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {showError && (
              <Typography variant="body2" color="secondary">
                Please enter first name and last name
              </Typography>
            )}
            <Typography
              color="secnodary"
              variant="h5"
              className={classes.typography}
            >
              {"I, "}
              <Input
                placeholder="Enter your first name"
                onBlur={(e) => {
                  setFirstName(e.target.value);
                  setShowError(false);
                }}
                inputProps={{ "aria-label": "description" }}
              />
              {"    "}
              <Input
                placeholder="Enter your last name"
                onBlur={(e) => {
                  setLastName(e.target.value);
                  setShowError(false);
                }}
                inputProps={{ "aria-label": "description" }}
              />
              {
                ", agree that I have read all of the areas of the document and have provided all accurate information as represented."
              }
            </Typography>

            <Typography variant="body2" className={classes.typography}>
              Confirmation Date and Time {dateTime}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (firstName.length > 0 && lastName.length > 0) {
                var payload={'firstName':firstName,'lastName':lastName}
                props.handleSubmit(payload);
                handleClose();
              } else {
                setShowError(true);
              }
            }}
            color="secondary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppointmentCancelConfirmation;
